module.exports = __webpack_public_path__ + "img/car-item1.b5a12d2c.png";